import React, { useCallback, useEffect, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import { isBlank } from "../../util/ext";

import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import PhotoOutlinedIcon from "@mui/icons-material/PhotoOutlined";
import Box from "@mui/material/Box";
import { Card, CardContent, CardHeader } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import ProgramImagesUploadDialog from "../edit/ProgramImagesUploadDialog";

const useStyles = makeStyles(theme => ({
  header: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },

  content: {
    paddingTop: 0,
  },

  logo: {
    maxHeight: 60,
    maxWidth: 200,
  },

  emptyLogo: {
    fontSize: 60,
  },
}));

const ProjectLogoCard = ({
  project,
  url,
  title = "Logo",
  darkBackground = false,
  onUrlUpdate,
}) => {
  const classes = useStyles();

  const [logoUrl, setLogoUrl] = useState(null);
  useEffect(() => {
    setLogoUrl(url);
  }, [url]);

  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const handleEditClick = useCallback(() => {
    setEditDialogOpen(true);
  }, []);

  const handleEditCancel = useCallback(() => {
    setEditDialogOpen(false);
  }, []);

  const handleEditSave = useCallback(
    data => {
      setLogoUrl(data.imageUrl);
      onUrlUpdate(data.imageUrl);
      setEditDialogOpen(false);
    },
    [onUrlUpdate],
  );

  return (
    <Card raised elevation={4} style={{ height: "100%" }}>
      <CardHeader
        titleTypographyProps={{
          variant: "h6",
          color: "primary",
        }}
        title={title}
        subheader={darkBackground ? "With Dark Background" : null}
        action={
          <Tooltip title="Edit">
            <IconButton onClick={handleEditClick} size="large">
              <EditIcon color="primary" fontSize="large" />
            </IconButton>
          </Tooltip>
        }
        classes={{ root: classes.header }}
      />
      <CardContent classes={{ root: classes.content }}>
        <Box display="flex" alignItems="center" justifyContent="center">
          {isBlank(logoUrl) ? (
            <PhotoOutlinedIcon className={classes.emptyLogo} />
          ) : (
            <img
              alt="Branding Logo"
              src={logoUrl}
              className={classes.logo}
              style={{ backgroundColor: darkBackground ? "grey" : "white" }}
            />
          )}
        </Box>
      </CardContent>
      {editDialogOpen && (
        <ProgramImagesUploadDialog
          open={editDialogOpen}
          project={project}
          onCancel={handleEditCancel}
          onApply={handleEditSave}
        />
      )}
    </Card>
  );
};

export default ProjectLogoCard;
